import React, { useState } from 'react'
import PropTypes from 'prop-types'
import map from 'lodash/fp/map'
import findKey from 'lodash/fp/findKey'
import Avatars from 'assets/avatars'

/**
 * Form field used to pick a kid's avatar.
 *
 * @param label - form label to the left of the picker
 * @param value - the key of the Avatars import (E.g. boy1)
 * @param onChange - callback to use when an avatar is picked
 */
const AvatarPicker = ({ label, value, onChange }) => {
  const [show, setShow] = useState(false)

  const onAvatarClick = (asset) => {
    // Persist the avatar's key not the svg asset URL
    onChange(findKey((avatar) => avatar === asset, Avatars))
    setShow(false)
  }

  return (
    <div className="flex items-center mb-2">
      <label htmlFor="name" className="w-16 text-right">
        {label}:
      </label>
      <div onClick={() => setShow(!show)}>
        {!value ? (
          <span className="flex flex-wrap items-center justify-center w-16 h-16 p-2 mx-4 text-sm text-center text-gray-400 rounded-full cursor-pointer bg-gray-50">
            Pick One
          </span>
        ) : (
          <div className="mx-4 cursor-pointer avatar">
            <img src={Avatars[value]} alt="Kid Avatar" />
          </div>
        )}
      </div>
      {show && (
        <div className="absolute top-0 left-0 flex flex-wrap justify-between w-full h-full px-8 overflow-y-scroll bg-white rounded-lg top-24 scrolling-hidden">
          <div className="w-full mt-4 mb-6 text-2xl text-center text-pink-400">
            Pick an Avatar
          </div>
          {map(
            (asset) => (
              <div key={asset} className="inline-block m-3 cursor-pointer avatar">
                <img src={asset} alt="Kid Avatar" onClick={() => onAvatarClick(asset)} />
              </div>
            ),
            Avatars
          )}
          {/* Hack to deal with overflow not respecting padding */}
          <div className="h-8 w-full" />
        </div>
      )}
    </div>
  )
}

AvatarPicker.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
}

export default AvatarPicker
